import { fromJS, Map } from 'immutable';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export class GrowthCanvasTrackingObject implements ITrackingObject {
  private _props: Map<string, any>;

  constructor(props?: any) {
    this._props = props && props.toMap ? props.toMap() : fromJS(props || {});
  }

  get name() {
    return TrackingObjectNamesEnum.canvas;
  }

  get properties() {
    return this._props.toJS();
  }
}
